export default __webpack_public_path__ + "static/media/geometry-artwork-2.5dab468d.webp";